/**
 * @desc factoryDirectFul
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/Batch/allocation/factoryDirectFul`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
